<div class="feedback-page-container" [class]="themeService.getTheme()" [style.background-color]="mobileStyle">
  <app-feedback/>
</div>
